import { getLeafRating } from "./leafRating";

export const filterByLeafRating = (restaurant, minLeafCount, verificationTier) => {
  const rating = getLeafRating(restaurant);

  if (minLeafCount && rating.count < minLeafCount) return false;

  if (verificationTier === "verified" && rating.tier !== "green-solid") {
    return false;
  }
  if (verificationTier === "guaranteed" && rating.tier === "gray") {
    return false;
  }

  return true;
};

export const filterBySelectedCuisines = (restaurant, selectedCuisines) => {
  const cuisineList = Object.values(selectedCuisines || {});
  if (cuisineList.length === 0) return true;
  return (restaurant.cuisine || []).some((c) => cuisineList.includes(c));
};
